


















































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DatePickerOnColumn extends Vue { 
    @Prop(Object) readonly tableItem: any
    @Prop(String) readonly cloumnName: any
    @Prop(Function) public notifcation: any
	@Prop() public trackid: any

	newDate = null as any
    menu = false

	get dateText() {
		let xDate = this.tableItem[`${this.cloumnName}`].split("-")
      	if (xDate.length === 3) {
			if (xDate[2].length == 2) {
				const [year, month, day] = this.tableItem[`${this.cloumnName}`].split("-")
				return `${day}/${month}/${year}`
			}
		}

		let zDate = this.tableItem[`${this.cloumnName}`].split("/")
      	if (zDate.length === 3) {
			if (zDate[2].length == 2) {
				const [day, month, year] = this.tableItem[`${this.cloumnName}`].split("/")
				return `${day}/${month}/${year}`
			}
		}

		return this.tableItem[`${this.cloumnName}`]
    }

	set dateText (newValue: any) {
		this.tableItem[`${this.cloumnName}`] = newValue === null ? "" : newValue
		
	}

	onKeyUp (e: any) {
		if (this.newDate == "" || this.newDate == null) return

		if (this.newDate.length == 2)
		this.newDate = this.maskFormat(this.newDate, "##/")

		if (this.newDate.length == 5)
		this.newDate = this.maskFormat(this.newDate.replaceAll("/", ""), "##/##/")

		this.newDate = this.newDate.substring(0, 10)
		if (this.newDate.length == 10)
		this.newDate = this.maskFormat(this.newDate.replaceAll("/", ""), "##/##/####")

		if (this.newDate.length == 10) {
			let reg = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
			if (!reg.test(this.newDate)) {
				this.newDate = ""
			}
		}

		if (this.newDate.length == 10) {
			let zDate = this.newDate.split("/")
			if (zDate.length === 3) {
				if (zDate[2].length == 4) {
					const [day, month, year] = this.newDate.split("/")
					this.dateText = `${year}-${month}-${day}`
				}
			}
		}

		if (this.newDate.length == 10)
		if (e.keyCode === 13) this.menu = false

		if (this.newDate.length == 10) {
			if (this.cloumnName === 'crPlan' && this.notifcation) {
				this.validateCrPlan()
			}

			if (this.cloumnName === 'transferPlanDate' && this.notifcation) {
				this.validateTransferPlanDate()
			}
		}
	}

	maskFormat(value: string, pattern: string) {
		let i = 0
		let	v = value.toString()
		return pattern.replace(/#/g, _ => v[i++])
	}

	validate () {
		if (this.cloumnName === 'inspection1PlanCRDate') {
			if (this.tableItem.inspection1PlanPJDate === '')
				this.notifcation('กรุณาให้ PJ กรอก Plan พร้อมให้เข้าตรวจ#1 มิฉะนั้นจะบันทึกข้อมูลการนัดตรวจไม่สำเร็จ!', "warning")
		}
		if (this.cloumnName === 'inspectionPlanCRDateLatest') {
			if (this.tableItem.inspection2PlanPJDate === '')
				this.notifcation('กรุณาให้ PJ กรอก Plan พร้อมให้เข้าตรวจ#2 มิฉะนั้นจะบันทึกข้อมูลการนัดตรวจไม่สำเร็จ!!', "warning")
		}
	}

	validateCrPlan() {
		// ตรวจสอบวันที่ห้ามย้อนหลัง
		if (this.tableItem.crPlan) {
			const today = new Date()
			today.setHours(0, 0, 0, 0)
			
			const crPlanDate = new Date(this.tableItem.crPlan)
			crPlanDate.setHours(0, 0, 0, 0)
			
			if (crPlanDate < today) {
				this.notifcation('วันที่ CR Plan ห้ามเป็นวันย้อนหลัง', 'warning')
				this.tableItem.crPlan = ''
				this.newDate = ''
				return
			}
	
			// ตรวจสอบ CR Plan ต้อง >= transferPlanDate
			if (this.tableItem.transferPlanDate) {
				const transferPlanDate = new Date(this.tableItem.transferPlanDate)
				transferPlanDate.setHours(0, 0, 0, 0)
				
				if (crPlanDate < transferPlanDate) {
					this.notifcation('วันที่ CR Plan ต้องเท่ากับหรือมากกว่าวันที่นัดโอน', 'warning')
					this.tableItem.crPlan = ''
					this.newDate = ''
				}
			}
		}
	}

	validateTransferPlanDate() {
		// ตรวจสอบวันที่ห้ามย้อนหลัง
		if (this.tableItem.transferPlanDate) {
			const today = new Date()
			today.setHours(0, 0, 0, 0)
			
			const transferPlanDate = new Date(this.tableItem.transferPlanDate)
			transferPlanDate.setHours(0, 0, 0, 0)
			
			if (transferPlanDate < today) {
				this.notifcation('วันที่นัดโอน ห้ามเป็นวันย้อนหลัง', 'warning')
				this.tableItem.transferPlanDate = ''
				this.newDate = ''
				return
			}

			if (this.tableItem.crPlan) {
				const crPlanDate = new Date(this.tableItem.crPlan)
				crPlanDate.setHours(0, 0, 0, 0)

				if (transferPlanDate > crPlanDate) {
					this.notifcation('วันที่นัดโอนต้องน้อยกว่าหรือเท่ากับวันที่ CR Plan', 'warning')
					this.tableItem.transferPlanDate = ''
					this.newDate = ''
					return
				}
			}
		}
	}

	onDateChange() {
		console.log('cloumnName', this.cloumnName)
		this.menu = false

		if (this.cloumnName === 'crPlan' && this.notifcation) {
			this.validateCrPlan()
		}

		if (this.cloumnName === 'transferPlanDate' && this.notifcation) {
			this.validateTransferPlanDate()
		}
	}
}
